
export enum TicketGeneralStatus {
  PENDING,
  INVALID,
  INVOICED
}
